export default ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="50"
    height="55"
    viewBox="0 0 50 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.8">
      <path
        d="M23.4481 50.8824H7.12723C5.25664 50.8824 3.73679 49.3625 3.73679 47.4919V7.50809C3.73679 5.6375 5.25664 4.11765 7.12723 4.11765H34.6405C36.5111 4.11765 38.0309 5.6375 38.0309 7.50809V24.6707C38.0309 25.5281 38.7324 26.2296 39.5897 26.2296C40.4471 26.2296 41.1485 25.5281 41.1485 24.6707V7.50809C41.1485 3.92279 38.2258 1 34.6405 1H7.12723C3.54193 1 0.619141 3.92279 0.619141 7.50809V47.4919C0.619141 51.0772 3.54193 54 7.12723 54H23.4481C24.3055 54 25.0069 53.2985 25.0069 52.4412C25.0069 51.5838 24.3133 50.8824 23.4481 50.8824Z"
        fill="#A2F7C9"
        stroke="#A2F7C9"
      />
      <path
        d="M29.8998 14.2737C29.8998 13.4163 29.1984 12.7148 28.341 12.7148H13.4153C12.5579 12.7148 11.8564 13.4163 11.8564 14.2737C11.8564 15.131 12.5579 15.8325 13.4153 15.8325H28.3488C29.2062 15.8325 29.8998 15.1388 29.8998 14.2737Z"
        fill="#A2F7C9"
        stroke="#A2F7C9"
      />
      <path
        d="M13.4153 22.5156C12.5579 22.5156 11.8564 23.2171 11.8564 24.0744C11.8564 24.9318 12.5579 25.6333 13.4153 25.6333H20.882C21.7394 25.6333 22.4409 24.9318 22.4409 24.0744C22.4409 23.2171 21.7394 22.5156 20.882 22.5156H13.4153Z"
        fill="#A2F7C9"
        stroke="#A2F7C9"
      />
      <path
        d="M12.8677 32.3164C12.3115 32.3164 11.8564 33.0179 11.8564 33.8752C11.8564 34.7326 12.3115 35.4341 12.8677 35.4341H17.7114C18.2676 35.4341 18.7227 34.7326 18.7227 33.8752C18.7227 33.0179 18.2676 32.3164 17.7114 32.3164H12.8677Z"
        fill="#A2F7C9"
        stroke="#A2F7C9"
      />
      <path
        d="M38.0811 53.458C31.9208 53.458 26.8994 48.4366 26.8994 42.2764C26.8994 36.1161 31.9208 31.043 38.0811 31.043C44.2413 31.043 49.2627 36.0644 49.2627 42.2246C49.2627 48.3849 44.2413 53.458 38.0811 53.458ZM38.0811 33.1136C33.0597 33.1136 28.9701 37.2032 28.9701 42.2246C28.9701 47.246 33.0597 51.3356 38.0811 51.3356C43.1024 51.3356 47.192 47.246 47.192 42.2246C47.192 37.2032 43.1024 33.1136 38.0811 33.1136Z"
        fill="#A2F7C9"
        stroke="#A2F7C9"
        strokeWidth="1.2"
      />
      <path
        d="M36.9435 46.6266C36.6329 46.6266 36.3223 46.4713 36.1152 46.2125L33.4234 42.8476C33.061 42.3817 33.1127 41.7605 33.5787 41.3982C34.0446 41.0358 34.6658 41.0876 35.0281 41.5535L36.8917 43.883L41.0848 38.2922C41.4472 37.8263 42.0684 37.7227 42.5343 38.0851C43.0002 38.4475 43.1038 39.0687 42.7414 39.5346L37.72 46.2643C37.5647 46.4713 37.2541 46.6266 36.9435 46.6266Z"
        fill="#A2F7C9"
        stroke="#A2F7C9"
        strokeWidth="1.2"
      />
    </g>
  </svg>
);
